import React from 'react';

const NotFound = () => {
	return (
		<div>
			<h1><x-lang>Not Found</x-lang></h1>
		</div>
	);
};

export default NotFound;
